import React, { memo } from 'react';

import useInlineLinkTracking from '@hooks/useInlineLinkTracking';
import { TrackingLocation } from '@tracking';
import { AuthoredContentReactToHtmlParser } from '@utils/reactHtmlParserTransform';

import styles from './bodyStyles.module.scss';

const Body = ({ content }): JSX.Element => {
  useInlineLinkTracking({
    trackingLocation: TrackingLocation.LandingPage,
    targetSelector: 'main',
  });

  return (
    <article className={styles.landingPageBody}>
      {AuthoredContentReactToHtmlParser(content)}
    </article>
  );
};

export default memo(Body);
